import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ServiceCard({ service, className = "" }) {
  const Icon = service.icon;
  return (
    <Link
      to={`/services/${service.slug}`}
      data-testid={`service-card-${service.slug}`}
      className={`group relative flex flex-col overflow-hidden rounded-2xl bg-white border border-brand-cream shadow-sm transition-all duration-300 hover:shadow-xl hover:-translate-y-1.5 ${className}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={service.heroImage}
          alt={service.grid}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/55 via-transparent to-transparent" />
        <span className="absolute top-4 left-4 grid place-items-center h-11 w-11 rounded-xl bg-white/95 text-brand-orange shadow-md">
          <Icon size={20} strokeWidth={1.9} />
        </span>
      </div>
      <div className="flex flex-1 flex-col p-6">
        <h3 className="text-lg font-semibold text-brand-dark leading-snug">{service.grid}</h3>
        <p className="mt-2 text-sm leading-relaxed text-brand-muted flex-1">{service.tagline}</p>
        <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold uppercase tracking-[0.04em] text-brand-orange">
          Explore
          <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </Link>
  );
}
